export default __webpack_public_path__ + "static/onboarding-2e8ccf09eca71812cfdc40be162a88ec.png";